import React from 'react';
import AgentsExport from '../AgentsExport';
import { agentProductionTerms as agProdTerms, TimePeriods } from '../../../constants';
import { views } from '../../constants/savedAgents';
import { setStateData } from '../../../common/helpers/state';
import { getHeaderText as getListingProfExportHeaderText } from '../../helpers/listingProficiencyHelpers';
import { tabIndexes } from '../../helpers/agentProductionHelpers';
import { tabModes } from '../../constants/agentProductionConstants';
import { tabs } from '../../constants/suggestedAgents';

export const exportCsv = (state, setState, selectedView, selectedAgents, currentTabId) => {
    const handleClose = () => {
        setStateData('showModal', false, setState);
    };

    const commonModalProps = ({
        size: 'lg',
        title: agProdTerms.exportData,
        showFooter: false,
        onClose: handleClose,
        show: true,
        footerClassName: '',
        dataLwtId: 'agent-production-modal',
    });

    const growthAnalysisColumnsByPeriod = {
        [TimePeriods[agProdTerms.last90Days]]: state.growthAnalysisColumnsL90,
        [agProdTerms.last12Months]: state.growthAnalysisColumnsLtm,
        [agProdTerms.yearToDate]: state.growthAnalysisColumnsYtd,
        [TimePeriods[agProdTerms.last12Months]]: state.growthAnalysisColumnsLtmIncDec,
        [TimePeriods[agProdTerms.yearToDate]]: state.growthAnalysisColumnsYtdIncDec,
    }[state.growthAnalysisPeriod];

    const isNewProducers = currentTabId === tabs.newProducers.id;
    const isCoopAgents = currentTabId === tabs.coopAgents.id;
    const overviewColumns = isNewProducers
        ? state.newProducersOverviewColumns
        : isCoopAgents ? state.coopAgentsOverviewColumns : state.overviewColumns;
    const contactInfoColumns = isNewProducers ? state.newProducersContactInfoColumns : state.contactInfoColumns;

    const buildAgentsExport = ({ defaultColumns, tabMode, ...restProps }) => (
        <AgentsExport
            handleClose={handleClose}
            selectedAgents={selectedAgents}
            defaultColumns={defaultColumns}
            tabMode={tabMode}
            currentSearchDates={state.currentSearchDates}
            currentTabId={currentTabId}
            {...restProps}
        />
    );

    const tabViews = {
        [tabIndexes.OVERVIEW]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: overviewColumns,
                tabMode: tabModes.OVERVIEW,
            }),
        },
        [tabIndexes.CONTACT_INFORMATION]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: contactInfoColumns,
                tabMode: tabModes.CONTACT_INFORMATION,
            }),
        },
        [tabIndexes.GROWTH_ANALYSIS]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: growthAnalysisColumnsByPeriod,
                tabMode: tabModes.GROWTH_ANALYSIS,
                growthAnalysisPeriod: state.growthAnalysisPeriod,
                timeIntervals: state.timeIntervals,
            }),
        },
        [tabIndexes.LISTING_PROFICIENCY]: {
            ...commonModalProps,
            title: getListingProfExportHeaderText(),
            children: buildAgentsExport({
                defaultColumns: state.listingProficiencyColumns,
                tabMode: tabModes.LISTING_PROFICIENCY,
            }),
        },
    };

    const modalPropsSettingsByView = ({
        ...tabViews,
        [views.overview]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: overviewColumns,
                tabMode: views.overview,
            }),
        },
        [views.contactInformation]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: contactInfoColumns,
                tabMode: views.contactInformation,
            }),
        },
        [views.growthAnalysis]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: state.growthAnalysisColumns ?? growthAnalysisColumnsByPeriod,
                tabMode: views.growthAnalysis,
                growthAnalysisPeriod: state.growthAnalysisPeriod,
                timeIntervals: state.timeIntervals,
            }),
        },
        [views.listingProficiency]: {
            ...commonModalProps,
            title: getListingProfExportHeaderText(),
            children: buildAgentsExport({
                defaultColumns: state.listingProfColumns,
                tabMode: views.listingProficiency,
            }),
        },        
        [views.activity]: {
            ...commonModalProps,
            title: agProdTerms.downloadData,
            children: buildAgentsExport({
                defaultColumns: state.activityColumns,
                tabMode: views.activity,
            }),
        },
    });

    const modalProps = modalPropsSettingsByView[selectedView];

    const showModal = !!modalProps;
    setState(prevState => ({ ...prevState, modalProps, showModal }));
};
